<app-meu-link link="https://www.diviprev.mg.gov.br/wp-content/uploads/2020/10/Regimento-Controle-interno.pdf" texto="Regimento Interno"></app-meu-link>
        <br><br>
      <p-fieldset legend="Portarias de Nomeação" [toggleable]="true" [collapsed]="true">
        <app-lista-arquivos [miniMode]="true" categoria="portNomeacaoCI"></app-lista-arquivos>
      </p-fieldset>
      
      <p-fieldset legend="Relatórios Auditoria Controle Interno" [toggleable]="true" [collapsed]="true">
        <app-lista-arquivos [miniMode]="true" categoria="relaudcontrinter"></app-lista-arquivos>
      </p-fieldset>

      <p-fieldset legend="Relatórios Trimestrais" [toggleable]="true" [collapsed]="true">
      <app-lista-arquivos [miniMode]="true" categoria="relTriCI"></app-lista-arquivos>
      </p-fieldset>
      
      <p-fieldset legend="Relatórios Semestrais" [toggleable]="true" [collapsed]="true">
      <app-lista-arquivos [miniMode]="true" categoria="relSemesCI"></app-lista-arquivos>
      </p-fieldset>

      <p-fieldset legend="Certificados" [toggleable]="true" [collapsed]="true">
      <app-lista-arquivos [miniMode]="true" categoria="certificadosCI"></app-lista-arquivos>
      </p-fieldset>     
